module.exports = __webpack_public_path__ + "img/2004.9f896839.jpg";